module.exports = __webpack_public_path__ + "img/theme6.16f809bc.png";